import React from 'react';
import PropTypes from 'prop-types';
import Photo from './Photo';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

class Bestof extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bestOf: null
        };
    }

    componentDidMount() {
        const props = this.props;
        fetch(`${props.paths.root}/${props.paths.apiGal}1&home=1`)
            .then(res => res.json())
            .then(bestOf => this.setState({bestOf}));
    }

    render() {
        const props = this.props;

        if (!this.state.bestOf) {
            return (
                <div/>
            );
        } else {
            return (
                <Row className="row-cols-2 row-cols-md-3 row-cols-lg-6">
                    {this.state.bestOf.map(photo => (
                        <Col key={photo.id}> <Photo photo={photo} onClick={props.onClick} paths={props.paths}
                            options={props.options}/> </Col>
                    ))}
                </Row>
            );
        }
    }
}

Bestof.propTypes = {
    paths: PropTypes.object,
    onClick: PropTypes.func,
    options: PropTypes.object
};

export default Bestof;
